var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.copyToClipboard}},[_c('span',{staticClass:"material-icons"},[_vm._v("content_copy")]),_vm._v(_vm._s(_vm.buttonTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }